export enum ViewModes {
	View,
	Edit,
	Design
}